module.exports = __webpack_public_path__ + "302bdb2eb653512f6980ad57903ee324.MP3";